type Props = { label?: string };

export function OrDivider({ label = "or" }: Props) {
  return (
    <div className="signin-or">
      <span className="signin-or-text">{label}</span>
    </div>
  );
}
